document.addEventListener('DOMContentLoaded', () => {
    const diagonalPictureComponents = [].slice.call(document.querySelectorAll('.diagonal-pictures'));

    diagonalPictureComponents.map(function (component) {
        component.classList.add(`count-${component.querySelectorAll('.img-container').length}`);
    });
});